export const getIsResetButton = (showReset: boolean,value: string, defaultValue: string | undefined): boolean => {
  return showReset && !!defaultValue && value !== defaultValue;
};
